import React, { useState } from "react";
import api, { formatError } from "@/lib/api";
import { toast } from "sonner";
import { Star, X } from "lucide-react";

/**
 * RateModal — trigger with an `application` object (must have id).
 * Both parties of a HIRED application can rate the other side (server enforces).
 */
export default function RateModal({ application, open, onClose, onDone }) {
  const [stars, setStars] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  if (!open || !application) return null;
  const submit = async () => {
    if (stars < 1) return toast.error("Please pick a star rating");
    setBusy(true);
    try {
      await api.post("/ratings", { application_id: application.id, stars, comment: comment.trim() || null });
      toast.success("Thanks — your review has been recorded");
      onDone?.();
    } catch (e) { toast.error(formatError(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose} data-testid="rate-modal">
      <div className="sarthi-card w-full max-w-md p-6" onClick={(e) => e.stopPropagation()}>
        <div className="mb-3 flex items-center justify-between">
          <h2 className="font-display text-xl font-extrabold">Rate this hire</h2>
          <button onClick={onClose}><X className="h-5 w-5" /></button>
        </div>
        <div className="mb-2 text-sm text-sarthi-muted">{application.worker_name || application.contractor_name || "Counterparty"} — {application.job_title}</div>
        <div className="mb-4 flex justify-center gap-1">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              data-testid={`star-${n}`}
              onMouseEnter={() => setHover(n)}
              onMouseLeave={() => setHover(0)}
              onClick={() => setStars(n)}
            >
              <Star className={`h-9 w-9 transition ${(hover || stars) >= n ? "fill-yellow-400 text-yellow-500" : "text-sarthi-muted"}`} />
            </button>
          ))}
        </div>
        <textarea
          data-testid="rate-comment"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={3}
          maxLength={1000}
          placeholder="Optional — what stood out (or didn't)?"
          className="w-full rounded-xl border-2 border-sarthi-border px-3 py-2 text-sm"
        />
        <button data-testid="rate-submit" onClick={submit} disabled={busy || stars < 1} className="sarthi-btn-primary mt-3 w-full py-2 text-white disabled:opacity-50">
          {busy ? "Sending…" : "Submit rating"}
        </button>
      </div>
    </div>
  );
}
